var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.plateList.length < 1 && !_vm.value.unique_id
    ? _c("empty", { attrs: { value: _vm.value } })
    : _c("div", { staticClass: "saas_module_plate_nav_inner" }, [
        _c("div", { staticClass: "saas_module_plate_nav", style: _vm.Styles }, [
          _vm.categoryList.length
            ? _c(
                "div",
                { staticClass: "tabs" },
                [
                  _c(
                    "el-tabs",
                    {
                      on: { "tab-click": _vm.tabChange },
                      model: {
                        value: _vm.activeTab,
                        callback: function ($$v) {
                          _vm.activeTab = $$v
                        },
                        expression: "activeTab",
                      },
                    },
                    _vm._l(_vm.categoryList, function (tab, index) {
                      return _c("el-tab-pane", {
                        key: tab.uid || index,
                        attrs: { label: tab.name, name: index + "" },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "content" },
            _vm._l(_vm.activityList, function (item, index) {
              return _c(
                "div",
                { key: item.id || index, staticClass: "news-info" },
                [
                  _c("div", { staticClass: "left" }, [
                    item.thumb
                      ? _c("img", {
                          staticClass: "img",
                          attrs: { src: item.thumb },
                        })
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "right" }, [
                    _c("div", { staticClass: "article-title" }, [
                      _vm._v(_vm._s(item.title)),
                    ]),
                    _c("div", { staticClass: "article-text" }, [
                      _vm._v(_vm._s(item.content)),
                    ]),
                    _c("div", { staticClass: "time" }, [
                      _vm._v(_vm._s(item.hd_start_time)),
                    ]),
                  ]),
                ]
              )
            }),
            0
          ),
          _vm.activityList.length
            ? _c("div", { staticClass: "more" }, [_vm._v("查看更多 >")])
            : _vm._e(),
        ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }